import { useState } from 'react';
import Modal from '@/common/Modal';
import Checkbox from '@/common/Checkbox';
import EditableTile from '@/common/EditableTile';
import Phone from '@/api/models/Phone';
import CloseIcon from '@/assets/icons/close-x.svg?react';
import styles from './Modal.module.scss';

interface IPhoneModalProps {
  isOpen: boolean;
  playerName: string;
  phoneCodes: string[] | undefined;
  mode: 'create' | 'edit' | undefined;
  phone: Phone | undefined;
  onClose: () => void;
  // eslint-disable-next-line no-unused-vars
  onSave: (phoneData: { label: string; number: string; isDefault: boolean }) => void;
}

function PhoneModal({ isOpen, onClose, onSave, playerName = '', phoneCodes, mode, phone }: IPhoneModalProps) {
  const [label, setLabel] = useState(phone?.code || '');
  const [number, setNumber] = useState(phone?.phoneNo || '');
  const [isDefault, setIsDefault] = useState(phone?.isDefault || false);
  const [showLabelError, setShowLabelError] = useState(false);

  const handleSave = () => {
    const labelAlreadyExists = phoneCodes?.includes(label.trim().toLowerCase());
    let shouldCheckLabel = true;
    if (mode === 'edit') shouldCheckLabel = phone?.code?.trim().toLowerCase() !== label.trim().toLowerCase(); // has original code changed
    if (shouldCheckLabel && labelAlreadyExists) {
      setShowLabelError(true);
      return;
    }
    onSave({
      label: label.trim(),
      number: number.trim(),
      isDefault,
    });
  };

  const handleCancel = () => {
    // Reset form
    setLabel('');
    setNumber('');
    setIsDefault(false);
    setShowLabelError(false);
    onClose();
  };

  return (
    <div data-testid="player-phone-modal-wrapper">
      <Modal isOpen={isOpen} onClose={handleCancel}>
        <div className={styles.container}>
          <div className={styles.titleWrapper}>
            <div className={styles.title}>{mode === 'create' ? 'Add New' : 'Edit'} Phone Number</div>
            <button type="button" className={styles.iconButton} aria-label="Close phone modal" onClick={handleCancel}>
              <CloseIcon aria-hidden="true" className={styles.icon} />
            </button>
          </div>
          {playerName && <div className={styles.playerName}>{playerName}</div>}

          <EditableTile label="Label" value={label} onChange={setLabel} alignment="left" variant="fullWidth" className={styles.tile} />

          <EditableTile label="Number" value={number} onChange={setNumber} alignment="left" variant="fullWidth" className={styles.tile} />

          <Checkbox label="Default Phone" checked={isDefault} onClick={() => setIsDefault(!isDefault)} className={styles.checkbox} />

          {showLabelError && <span className={styles.error}>The address label already exists, please enter a different one.</span>}

          <div className={styles.buttonContainer}>
            <button onClick={handleCancel} className={styles.cancelButton}>
              Cancel
            </button>
            <button onClick={handleSave} className={styles.saveButton} disabled={!label.trim() || !number.trim()}>
              Save
            </button>
          </div>
        </div>
      </Modal>
    </div>
  );
}

export default PhoneModal;
